import {
    server
} from "@/api";

const prefix = 'api/my-eshow'

export const bookmarkedCompanies = async (params = {}) => {
    return await server().get(`${prefix}/bookmarked-companies`, { params });
}

export const bookmarkedProducts = async (params = {}) => {
    return await server().get(`${prefix}/bookmarked-products`, { params });
}

export const bookmarkedServices = async (params = {}) => {
    return await server().get(`${prefix}/bookmarked-services`, { params });
}

export const mySchedule = async (params = {}) => {
    return await server().get(`${prefix}/sessions`, { params });
}

const MyEshowApi = {
    bookmarkedCompanies,
    bookmarkedProducts,
    bookmarkedServices,
    mySchedule
}

export default MyEshowApi;